<template>
  <div>
    <el-button type="primary" @click="handleSelectionChange()" icon="el-icon-search">搜索产品</el-button>
    <el-dialog title :visible.sync="innerVisible" style="width:100%" append-to-body>
      <div style="width:100%">
        <el-table :data="tableData" class="tb-edit" style="width: 100%" ref="multipleTable">
          <el-table-column type="selection" width="65"></el-table-column>
          <el-table-column label="产品名称" prop="name"></el-table-column>
          <el-table-column label="模块名称" prop="moduleName"></el-table-column>
          <el-table-column label="永久/租赁">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.value" active-text="租赁" inactive-text="永久"></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="node" label="日期" width="328">
            <template slot-scope="scope">
              <el-date-picker
                v-if="scope.row.value"
                v-model="scope.row.startTime"
                type="date"
                placeholder="开始日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd 00:00:00"
              ></el-date-picker>
              <el-date-picker
                v-if="scope.row.value"
                v-model="scope.row.endTime"
                type="date"
                placeholder="结束日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd 00:00:00"
              ></el-date-picker>
            </template>
          </el-table-column>
          <el-table-column prop="node" label="节点" width="88">
            <template slot-scope="scope">
              <el-input size="small" v-model="scope.row.node" clearable></el-input>
            </template>
          </el-table-column>
        </el-table>
        <el-button
          type="primary"
          @click="savebutton()"
          style="color: #FFF;
    background-color: #409EFF;
    border-color: #409EFF;
    font-size:20px;
    width:150px;
    margin:10px"
        >确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  //接收父组件传值
  props: {
    ruleForm: Object,
    index: Number
  },
  data() {
    return {
      innerVisible: false,
      tableData: [],
      xuanzhongshuju: {},
      search: ""
    };
  },
  methods: {
    //子组件传值给父组件
    savebutton() {
      this.innerVisible = false;
      this.xuanzhongshuju = this.$refs.multipleTable.selection;
      this.$emit("ievent", this.xuanzhongshuju, this.index);
    },
    //接收父组件传值回显DOM
    handleSelectionChange() {
      if (this.tableData.length == 0) {
        for (var i = 0; i < this.ruleForm.module.length; i++) {
          this.tableData.push(this.ruleForm.module[i]);
        }
      }
      this.innerVisible = true;
    }
  }
};
</script>
<style scoped>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 150px;
  float: left;
}
</style>